export default {
  apiKey: "AIzaSyB21ngJEkybL5rthTdxRaXTLwrBiLIVVf4",
  authDomain: "odds-7948d.firebaseapp.com",
  projectId: "odds-7948d",
  storageBucket: "odds-7948d.appspot.com",
  messagingSenderId: "343468046896",
  appId: "1:343468046896:web:c320ff73984f5612738bf5",
};
